import React from 'react';

import { Flex, Color } from '@tapresearch/ui/components';
import { CustomBarItemLabelProps } from '@tapresearch/ui/charts';

export interface CustomCrossTabBarLabelProps extends CustomBarItemLabelProps {
  usePercentage: boolean;
}

export function CustomCrossTabBarLabel(props: CustomCrossTabBarLabelProps) {
  const { usePercentage, barProps } = props;

  if (!barProps) {
    return null;
  }

  const { id: answerId } = barProps.bar.data;

  return (
    <Flex
      align="stretch"
      h="full"
      w="full"
      bg={barProps.bar.color as Color}
      fontWeight="medium"
      fontSize="sm"
      color="gray.900"
    >
      <Flex
        {...{
          position: 'absolute',
          justify: 'center',
          w: 'full',
          left: 0,
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          mt: '-1px',
        }}
      >
        {`${
          usePercentage
            ? `${barProps.bar.data.value}%`
            : barProps.bar.data.data[`${answerId}_total`]
        }`}
      </Flex>
    </Flex>
  );
}

export function getCustomCrossTabBarLabel({
  usePercentage,
}: {
  usePercentage: boolean;
}) {
  // eslint-disable-next-line react/display-name
  return (props: React.PropsWithChildren<CustomCrossTabBarLabelProps>) => (
    <CustomCrossTabBarLabel {...{ ...props, usePercentage }} />
  );
}
